import React from 'react';
import MarketingLayout from './MarketingLayout';
import Section from './components/Section';
import PricingCard from './components/PricingCard';
import CTABand from './components/CTABand';
import useSiteConfig from './useSiteConfig';
import { COLOR } from '../../components/ss/tokens';

const DEFAULT_PLANS = [
  {
    name: 'Basic Care',
    price: 'From KES 2,500',
    period: 'per visit',
    description: 'Essential nursing care for straightforward home health needs.',
    highlights: [
      'Vital signs monitoring',
      'Medication administration',
      'Wound dressing (simple)',
      'Post-visit report',
      'NHIF accepted',
    ],
    cta: { label: 'Get started', href: '/contact' },
  },
  {
    name: 'Comprehensive Care',
    price: 'From KES 5,000',
    period: 'per visit',
    description: 'Full-scope clinical care coordinated with your doctor.',
    highlights: [
      'Everything in Basic',
      'Doctor-coordinated care plan',
      'Complex wound management',
      'Physiotherapy sessions',
      'Remote vital monitoring',
      'Priority nurse matching',
    ],
    featured: true,
    cta: { label: 'Get started', href: '/contact' },
  },
  {
    name: 'Palliative & Elderly',
    price: 'Custom',
    period: 'monthly packages',
    description: 'Long-term, compassionate care tailored to ongoing needs.',
    highlights: [
      'Dedicated caregiver',
      'Daily or weekly visits',
      'Family progress updates',
      'Medication management',
      'Dietary & mobility support',
      'Insurance coordination',
    ],
    cta: { label: 'Contact us', href: '/contact' },
  },
];

export default function Pricing() {
  const { config } = useSiteConfig();
  const plans = (config?.pricing?.plans?.length > 0) ? config.pricing.plans : DEFAULT_PLANS;
  const cta = config?.cta_band || {};

  return (
    <MarketingLayout title="Pricing — Benevita Home Health Care">
      <Section
        eyebrow="Pricing"
        title="Transparent, affordable care"
        subtitle="No hidden fees. NHIF-friendly. Private insurance accepted."
        background={COLOR.bgMarketing}
        style={{ paddingTop: 80, paddingBottom: 16 }}
      >
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: 28,
          marginTop: 48,
          maxWidth: '100%',
          margin: '48px auto 0',
        }}>
          {plans.map((plan, i) => (
            <PricingCard key={i} tier={plan} />
          ))}
        </div>

        {/* Insurance note */}
        <div style={{
          maxWidth: 680, margin: '56px auto 0',
          background: COLOR.blueBg, borderRadius: 12,
          padding: '24px 28px', textAlign: 'center',
        }}>
          <p style={{ margin: 0, color: COLOR.primaryDark, fontSize: 15, lineHeight: 1.6 }}>
            <strong>NHIF, AAR, Jubilee, APA, Britam, Madison, UAP</strong> and 6 more insurers
            accepted. Contact us to verify your cover before your first visit.
          </p>
        </div>
      </Section>

      <CTABand config={config} />
    </MarketingLayout>
  );
}
